import { faHourglassEnd } from '@fortawesome/pro-duotone-svg-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Plans } from 'api/billing/types';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { Layout } from 'components/organisms/home/overview/layout';
import { ProductiveHeading03 } from 'components/styles';
import { useAccountDataQuery } from 'queries/account';
import { usePlanName } from 'queries/billing';

const Title = styled.div`
  ${ProductiveHeading03};
`;

export const TrialExpired = ({
  currentPlan,
}: {
  currentPlan: Plans | null;
}) => {
  const { data: accountData } = useAccountDataQuery();
  const currentPlanName = usePlanName(currentPlan);

  return (
    <Layout
      right={null}
      main={
        <EmptyStateContainer>
          <EmptyState
            image={<EmptyStateIcon icon={faHourglassEnd} />}
            title={
              <Title>
                <FormattedMessage
                  id="billing.trial.expired.modal.title"
                  values={{
                    planName: currentPlanName,
                  }}
                />
              </Title>
            }
            message={
              <FormattedMessage
                id="billing.trial.expired.modal.content"
                values={{
                  b: (chunk) => <b>{chunk}</b>,
                  accountOwnerEmail:
                    accountData?.billingMeta.accountAdmin.emailId,
                }}
              />
            }
          />
        </EmptyStateContainer>
      }
    />
  );
};

export const SubscriptionExpired = () => {
  const { data: accountData } = useAccountDataQuery();

  return (
    <Layout
      right={null}
      main={
        <EmptyStateContainer>
          <EmptyState
            image={<EmptyStateIcon icon={faHourglassEnd} />}
            title={
              <Title>
                <FormattedMessage id="billing.subscription.expired.modal.title" />
              </Title>
            }
            message={
              <FormattedMessage
                id="billing.subscription.expired.modal.content"
                values={{
                  b: (chunk) => <b>{chunk}</b>,
                  accountOwnerEmail:
                    accountData?.billingMeta.accountAdmin.emailId ?? '',
                }}
              />
            }
          />
        </EmptyStateContainer>
      }
    />
  );
};
